module.exports = __webpack_public_path__ + "static/media/night_flight_sample_6.0b0ecd54.jpg";